const THEME_KEY = 'theme';
const DEFAULT_APPLIED_KEY = 'theme-default-applied';

/**
 * Starts each browser on the light theme instead of Auto. It runs once per
 * browser, so a later pick of Auto in the settings sticks.
 */
export function applyDefaultTheme() {
  try {
    if (localStorage.getItem(DEFAULT_APPLIED_KEY)) {
      return;
    }
    if (!localStorage.getItem(THEME_KEY)) {
      localStorage.setItem(THEME_KEY, 'light');
    }
    localStorage.setItem(DEFAULT_APPLIED_KEY, 'true');
  } catch {
    // Storage is unavailable; the app falls back to Auto.
  }
}
